import ScannerQR from "@/pages/ScannerQR";

// Use the same scanner for client check-in and bilateral agreement approval.
export default function ArtistTools() {
  return <ScannerQR />;
}
